
import React, { useEffect, useState } from 'react'
import styled from "styled-components"
import {mobile} from "../responses"
import { publicRequest } from '../requestMethod'
import { toast } from 'react-hot-toast'
import { Link, useNavigate } from 'react-router-dom'

const Container=styled.div`
    width: 100vw;
    height: 100vh;
    background: linear-gradient(rgba(255,255,255,.5),rgba(255,255,255,.1)), url("https://i.ibb.co/zGrdRXQ/freestocks-3-Q3ts-J01nc-unsplash.jpg") center center/cover;
    display: flex;
    align-items: center;
    justify-content: center;
    `
const Wrapper=styled.div`
    width: 40%;
    background-color: rgba(255,255,255);
    padding: 20px;
    ${mobile({width:"75%"})};
`
const Title=styled.h1`
    font-style: 24px;
    font-weight: 300;
`
const Form=styled.form`
    display: flex;
    flex-wrap: wrap;
`
const Input=styled.input`
    flex: 1;
    margin: 20px 10px 0px 0px ;
    min-width: 40%;
    padding: 10px;
`
const Agreement=styled.span`
    font-size: 12px;
    margin-block: 20px;
`
const Button=styled.button`
    width: 40%;
    border:none ;
    cursor: pointer;
    padding: 15px 20px;
    background-color: teal;
    color: white;
    cursor: pointer;
`

const Register = () => {
    const navigate=useNavigate()
    const [firstName,setFirstName]=useState("")
    const [lastName,setlastName]=useState("")
    const [emailId,setemail]=useState("")
    const [username,setuserName]=useState("")
    const [password,setpassword]=useState()
    const [confirmpassword,setconfirmpassword]=useState()
    const [isAdmin,setisAdmin]=useState(true)
    const [passwordMatch,setpasswordMatch]=useState(false)
    const [diasbleButton,setdiasbleButton]=useState(false)

    const handleSubmit=async(e)=>{
        setdiasbleButton(true)
        e.preventDefault()
        try {
            const data = await publicRequest.post("/auth/register",{firstName,lastName,emailId,username,password,isAdmin})
            console.log({data});
            setdiasbleButton(false)
            toast.success("registration successfull")
            navigate("/login")
        } catch (error) {
            setdiasbleButton(false)
         console.log({error});
        toast.error("error");
        //  console.log(error?.response?.data);
            
        }
        
    }

    useEffect(()=>{
        // console.log({confirmpassword,password});
        
        if(confirmpassword!==password){
            setpasswordMatch(true)
        }
        else
        {
            setpasswordMatch(false)
        }
    },[confirmpassword,password])
  return (
    <Container>
      <Wrapper>
        <Title>
            CREATE AN ACCOUNT
        </Title>
        <Form onSubmit={handleSubmit}>
            <Input placeholder="firstname" onChange={(e)=>setFirstName(e.target.value)}/>
            <Input placeholder="lastname" onChange={(e)=>setlastName(e.target.value)}/>
            <Input placeholder="username" onChange={(e)=>setuserName(e.target.value)}/>
            <Input placeholder="email" onChange={(e)=>setemail(e.target.value)}/>
            <Input placeholder="password" type='password'  onChange={(e)=>setpassword(e.target.value)}/>
            <Input placeholder="confirm password"  type='password' onChange={(e)=>setconfirmpassword(e.target.value)}/>
            <Agreement>
                By creating an account,I consent to the processing of my personal data in accordance with the <b>PRIVACY POLICY</b>
            </Agreement>
            <div style={{width:"100%",margin:"10px center"}}>
                {   passwordMatch &&
                    
                    <span style={{color:"red"}}>password didn't match</span>
                }
                <div>
                already Have account?
                <Link to={"/login"}>Login</Link>
                </div>
            </div>

            <Button disabled={diasbleButton}
            style={{opacity:diasbleButton?.5:1,
                    cursor:diasbleButton?"not-allowed":"default"
            }}
            >CREATE</Button>
        </Form>
      </Wrapper>
    </Container>
  )
}

export default Register